// extracted by mini-css-extract-plugin
export var container = "_67-0";
export var infoButton = "_67-1";
export var label = "_67-3";
export var labelExpanded = "_67-4";
export var price = "_67-5";
export var priceExpanded = "_67-6";
export var title = "_67-2";